import { render, staticRenderFns } from "./P-Carousel.vue?vue&type=template&id=54c81001&scoped=true&lang=pug&"
import script from "./P-Carousel.vue?vue&type=script&lang=js&"
export * from "./P-Carousel.vue?vue&type=script&lang=js&"
import style0 from "./P-Carousel.vue?vue&type=style&index=0&id=54c81001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c81001",
  null
  
)

export default component.exports